module.exports = __webpack_public_path__ + "img/sdk3.c5b098e7.png";